import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import pic from "../assets/images/Logo-2.png";
import { db } from "../components/Firebase";
import { saveUser } from "../redux/actions/action";

const Signin = () => {
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const location = useLocation();
  const dispatch = useDispatch()
  const navigate = useNavigate();
  if (location.pathname === "/dashboard") {
    return <Outlet />;
  }

  return (
    <div
      style={{
        height: 720,
        alignItems: "center",
        justifyContent: "center",
        display: "flex",
      }}
    >
      <div
        style={{
          width: 400,
          height: 500,
          backgroundColor: "#a3a3a3",
          borderRadius: 10,
          justifyContent: "center",
        }}
      >
        <div
          // className="col-md-3"
          style={{
            textAlign: "center",
            alignItems: "center",
            justifyContent: "center",
            marginTop: 20,
          }}
        >
          <img
            style={{ width: "150px" }}
            className="img-responsive"
            src={pic}
          />
        </div>
        <div
          style={{
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
          }}
        >
          <div
            style={{
              flex: 1,

              margin: 10,
              width: 300,
              height: 400,
              borderRadius: 10,
              backgroundColor: "white",
              // display: "grid",
            }}
          >
            <div
              style={{
                padding: 15,
                justifyContent: "center",
                marginTop: 20,
              }}
            >
              <h3>Username:</h3>
              <div style={{ width: "100%" }}>
                <input
                  value={userName}
                  onChange={(e) => {
                    setUserName(e.target.value);
                  }}
                  style={{
                    width: "100%",
                    paddingBlock: 10,
                    paddingInline: 5,
                    borderRadius: 10,
                    outline: "none",
                  }}
                />
              </div>
              <h3>Password:</h3>
              <div>
                <input
                  value={password}
                  type="password"
                  onChange={(e) => {
                    setPassword(e.target.value);
                  }}
                  style={{
                    width: "100%",
                    paddingBlock: 10,
                    paddingInline: 5,
                    borderRadius: 10,
                    outline: "none",
                  }}
                />
              </div>
              <div
                style={{
                  justifyContent: "center",
                  alignItems: "center",
                  display: "flex",
                  marginTop: 30,
                }}
              >
                <button
                  onClick={() => {
                    if (!userName || !password)
                      return alert("Please enter the credentials!");
                    db.collection("config")
                      .doc("admin")
                      .get()
                      .then((doc) => {
                        const data = doc.data();
                        const usernameFirebase = data?.username || "";
                        const passwordFirebase = data?.password || "";
                        if (
                          usernameFirebase === userName &&
                          passwordFirebase === password
                        ) {
                          dispatch(saveUser(true))
                          navigate("/dashboard");
                        } else {
                          alert("Invalid Username or Password!");
                        }
                      });
                  }}
                  style={{
                    padding: 10,
                    width: 150,
                    borderRadius: 10,
                    backgroundColor: "#a3a3a3",
                  }}
                >
                  <h4 style={{ color: "white" }}>Signin</h4>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signin;
